var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.137 10.164C.122 4.687 4.515.216 9.992.137a9.726 9.726 0 0 1 9.871 9.702 10 10 0 0 1-9.855 10.024 9.726 9.726 0 0 1-9.871-9.699M16.183 3.71a8.63 8.63 0 0 0-6.175-2.473 8.9 8.9 0 0 0-8.77 8.924 8.625 8.625 0 0 0 8.754 8.602 8.9 8.9 0 0 0 8.77-8.922 8.63 8.63 0 0 0-2.579-6.13M10 5.22a.55.55 0 0 1 .55.519v5.959a.55.55 0 0 1-1.1.032V5.77a.55.55 0 0 1 .55-.55m.02 7.62h-.036l-.044.003a.757.757 0 0 0-.701.786.765.765 0 0 0 .762.736.758.758 0 0 0 .756-.786.764.764 0 0 0-.738-.738",
    clipRule: "evenodd"
  })));
};
export default SvgExclamation;